import React from 'react';
import { useIntl } from 'react-intl';

import { DeleteDialogWizard, useDialogWizardState } from '@futrli/ui-components/components/dialog-wizard';

import { useRouteIds } from '../../../hooks/useRouteIds';
import { COADisplayAccount } from '../../types';
import { useCoaApiView } from '../../hooks/useCoaApiView';

interface DeleteSwitchRuleDialogProps {
  coaRow: COADisplayAccount;
  isOpen: boolean;
  onClose: () => void;
}

export const DeleteSwitchRuleDialog = ({ coaRow, isOpen, onClose }: DeleteSwitchRuleDialogProps) => {
  const intl = useIntl();
  const { workspaceId, organisationId } = useRouteIds();

  const { isDeletingSwitchRule, errorDeletingSwitchRule, deleteSwitchRule } = useCoaApiView(
    workspaceId,
    organisationId
  );

  const { screen, handleAction, handleClose } = useDialogWizardState({
    isLoading: isDeletingSwitchRule,
    error: errorDeletingSwitchRule,
    onAction: () => deleteSwitchRule(coaRow.id),
    onClose
  });

  return (
    <DeleteDialogWizard
      isOpen={isOpen}
      onClose={handleClose}
      onDelete={handleAction}
      screen={screen}
      title={intl.formatMessage({ id: 'common.remove_switch_rule', defaultMessage: 'Remove switch rule' })}
      subtitle={coaRow.name}
      deleteDescription={intl.formatMessage({
        id: 'predict.coa.delete_switch_rule_description',
        defaultMessage: 'Are you sure you want to remove the switch rule?'
      })}
      loadingMessage={intl.formatMessage({
        id: 'common.removing_switch_rule',
        defaultMessage: 'Removing switch rule....'
      })}
      successMessage={intl.formatMessage({
        id: 'predict.coa.switch_rule_removed',
        defaultMessage: 'Switch rule successfully removed'
      })}
      errorMessage={errorDeletingSwitchRule?.message}
      dataTestId="delete-switch-rule-dialog"
      deleteButtonText={intl.formatMessage({ id: 'ui.drag_list_item.remove', defaultMessage: 'Remove' })}
    />
  );
};
